import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GraphQLError } from "graphql";
import { FinancierAssignPanelGQL, FinancierAssignListGQL } from "../../../../generated/graphql";
import { NavigationService } from "../../service/navigation.service";
import { SnackBarService } from "../../service/snack.bar.service";


@Component({
  selector: "assgin-ef-dialog",
  templateUrl: "assgin-ef-dialog.html",
})
export class AssignEFDialog {
  assignEfPanelForm: FormGroup;
  projectID: string;
  financierID: any;
  financierList: any = [];
  contactList: any = [];


  constructor(
    private financierAssignListGQL: FinancierAssignListGQL,
    private financierAssignPanelGQL: FinancierAssignPanelGQL,
    private snackBarService: SnackBarService,
    private navigationService: NavigationService,
    public dialogRef: MatDialogRef<AssignEFDialog>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.projectID = data.project_id;
    this.financierID = data.financier_id;
    this.initFormControl();
    this.getData();

  }


  private initFormControl() {
    this.assignEfPanelForm = new FormGroup({
      selectedFinancier: new FormControl('', [Validators.required]),
      selectedContacts: new FormControl('', [Validators.required]),
      financial_limit: new FormControl('', [Validators.required, Validators.min(1)]),
      interest_rate : new FormControl(3,[Validators.min(0) , Validators.max(100)])
    });

  }


  getData() {
    if (this.financierID) {
      this.financierAssignListGQL.fetch({
        projectId: this.projectID,
        financierId: this.financierID
      }).subscribe(result => {
        if (result.errors) {
          this.snackBarService.show(result.errors.map(x => x.message).join(','));
          this.navigationService.backPerviousPage();
        }
        let data = result.data.panelFinancierList;
        this.financierList = data;

        let invitedContactIds: any = [];
        let invitations = data[0].projectInvitation?.find(x => x.projectId == this.projectID)?.invitation;
        if (invitations && invitations.length > 0) {
          invitedContactIds = invitations.map(x => x.contactInfo.id);
        }
        // filter contact list to remove already invited contacts
        this.contactList = data[0].financierContact.filter(function (el) {
          return invitedContactIds.indexOf(el.id) === -1;
        });

        this.assignEfPanelForm.controls.selectedFinancier.setValue(this.financierID);
        this.assignEfPanelForm.controls.financial_limit.setValue(data[0]?.financialLimit);

      });
    }
    else {
      this.financierAssignListGQL.fetch({ projectId: this.projectID })
        .subscribe(result => {
          if (result.errors) {
            this.snackBarService.show(result.errors.map(x => x.message).join(','));
            this.navigationService.backPerviousPage();
          }
          this.financierList = result.data.panelFinancierList;
        });
    }
  }

  onFinancierChange(financierID) {
    let financier = this.financierList.find(x => x.id == financierID);
    this.contactList = financier.financierContact;
  }



  assignPanel(value) {
    const data = value.controls;
    if (this.assignEfPanelForm.valid) {
      this.financierAssignPanelGQL.mutate({
        input: {
          projectId: this.projectID,
          financierId: data.selectedFinancier.value,
          contactIds: data.selectedContacts.value,
          financialLimit: data.financial_limit.value,
          interestRate: data.interest_rate.value
        }
      }).subscribe(result => {
        if (result.data.assignPanel) {
          this.snackBarService.show("Financier assigned successfully.");
          this.dialogRef.close(true);
        }
      }, (err: GraphQLError) => {
        this.snackBarService.showMutationError(err);
      });
    } else {
      this.snackBarService.show("Please complete or correct the required field(s).");
    }
  }
}
